import { Button, Modal, message } from "antd";
import { useState } from "react";

import * as S from "./styles";

export const CreateQuestionModal = ({ open, onCancel, onSubmit }) => {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [options, setOptions] = useState([""]);
  const [questionType, setQuestionType] = useState("multiple_choice");
  const [isMultipleChoice, setIsMultipleChoice] = useState(true);

  const handleAddOption = () => {
    setOptions([...options, ""]);
  };

  const handleRemoveOption = (index) => {
    const newOptions = options.filter((_, i) => i !== index);
    setOptions(newOptions);
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleQuestionTypeChange = (type) => {
    setQuestionType(type);
    setIsMultipleChoice(
      type === "multiple_choice" || type === "multiple_answers"
    );

    // Reset options when changing type
    if (type === "text") {
      setOptions([""]);
    } else if (options.length === 1 && options[0] === "") {
      setOptions(["", ""]);
    }
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingSubmit(true);

      const formData = new FormData(e.currentTarget);
      const question = formData.get("question").toString();

      const validOptions = isMultipleChoice
        ? options.filter((option) => option.trim() !== "")
        : [];

      if (isMultipleChoice && validOptions.length < 2) {
        throw new Error(
          "Perguntas devem ter pelo menos 2 opções de justificativa"
        );
      }

      await onSubmit({
        question,
        options: validOptions,
        isMultipleChoice,
        questionType,
      });
    } catch (error) {
      console.error("failed to create question", error);
      message.error(error.message);
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <Modal
      title="Registrar Nova Pergunta"
      open={open}
      onCancel={onCancel}
      cancelText="Cancelar"
      destroyOnClose={true}
      closable={false}
      okButtonProps={{
        style: {
          display: "none",
        },
      }}
      width={600}
    >
      <S.Container onSubmit={handleSubmit}>
        <textarea
          name="question"
          placeholder="Nova Pergunta"
          rows={4}
          maxLength={200}
          required
        />

        <div className="question-type">
          <span>Tipo de pergunta:</span>
          <select
            value={questionType}
            onChange={(e) => handleQuestionTypeChange(e.target.value)}
          >
            <option value="text">Texto livre</option>
            <option value="multiple_choice">Múltipla escolha (SIM/NÃO)</option>
            <option value="multiple_answers">Múltiplas respostas</option>
          </select>
        </div>

        {isMultipleChoice && (
          <div className="options-container">
            <h4>
              {questionType === "multiple_answers"
                ? "Opções de resposta:"
                : "Opções de justificativa:"}
            </h4>
            {options.map((option, index) => (
              <div key={index} className="option-row">
                <input
                  type="text"
                  value={option}
                  onChange={(e) => handleOptionChange(index, e.target.value)}
                  placeholder={`Opção ${index + 1}`}
                  required
                />
                {options.length > 1 && (
                  <Button
                    type="text"
                    danger
                    onClick={() => handleRemoveOption(index)}
                  >
                    Remover
                  </Button>
                )}
              </div>
            ))}

            <Button
              type="dashed"
              onClick={handleAddOption}
              style={{ marginTop: 8 }}
            >
              + Adicionar Opção
            </Button>
          </div>
        )}

        <Button
          type="primary"
          htmlType="submit"
          disabled={loadingSubmit}
          id="app-button"
        >
          {loadingSubmit ? "Carregando..." : "Registrar"}
        </Button>
      </S.Container>
    </Modal>
  );
};
